// extracted by mini-css-extract-plugin
var _1 = "BirdviewAttentionRowHeader-moduleactions__yF9fu";
var _2 = "BirdviewAttentionRowHeader-moduleheader__voE8d";
var _3 = "BirdviewAttentionRowHeader-modulereason__gk3gO";
var _4 = "BirdviewAttentionRowHeader-moduletoggle__Q2t_r";
export { _1 as "actions", _2 as "header", _3 as "reason", _4 as "toggle" }
